import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from "react-bootstrap";
import { ERROR_ICON } from "../icons.js";
import IconText from "./IconText.js";
export default function ErrorAlert(props) {
    const { className, ...rest } = props;
    return (_jsx(Alert, { variant: "danger", className: "mb-0 " + (className ?? ""), ...rest, children: _jsx(IconText, { ...ERROR_ICON, children: props.children }) }));
}
